var App = App || {};

App.WidgetResources = (function ($) {
    'use strict';

    function Init(widget) {
        const animate = widget;
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".reusable-resourcesItem", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);